import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

function MobileRestriction({ children }) {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const resizeMobileView = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    resizeMobileView();
    window.addEventListener("resize", resizeMobileView);
    return () => window.removeEventListener("resize", resizeMobileView);
  }, []);
  if (isMobileView) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px", padding: "20px" }}>
        <h2>🚧📵 Mobile View Not Supported</h2>
        <p>Please use a laptop or desktop to access this platform.</p>
      </div>
    );
  }
  return <>{children}</>;
}

export default MobileRestriction;
